import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#1546a8',
    main: '#1e5bd8',
    light: '#4f86ec'
  },
  secondary: {
    contrastText: white,
    dark: '#0b5cad',
    main: '#2f80ed',
    light: '#5b9cf2'
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: '#1546a8',
    main: '#1e5bd8',
    light: '#4f86ec'
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: '#1e293b',
    secondary: '#64748b',
    link: '#1e5bd8'
  },
  background: {
    default: '#f5f7fb',
    paper: white
  },
  icon: '#64748b',
  divider: '#e6e9ef'
};
